import { render, staticRenderFns } from "./ListInitialReport.vue?vue&type=template&id=171a4733&scoped=true&"
import script from "./ListInitialReport.vue?vue&type=script&lang=js&"
export * from "./ListInitialReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171a4733",
  null
  
)

export default component.exports